// ============================================================================
// AUTH API FUNCTIONS
// ============================================================================

import { auth } from '../firebase/config';

export const getCurrentUserToken = async (): Promise<string | null> => {
  const user = auth.currentUser;
  if (!user) return null;
  try {
    return await user.getIdToken();
  } catch (error) {
    console.error('Error getting user token:', error);
    return null;
  }
};

export const authenticatedFetch = async (
  url: string,
  options: RequestInit = {}
): Promise<Response> => {
  const token = await getCurrentUserToken();
  if (!token) throw new Error('User not authenticated');
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    ...options.headers,
  };
  return fetch(url, { ...options, headers });
};

